import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { pluck } from 'ramda';
import { SharedConstants } from '../../../shared.constants';

@Component({
  selector: 'double-bar-line-chart',
  templateUrl: './double-bar-line-chart.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class DoubleBarLineChartComponent implements OnInit {
  @Input() public data: any = [];
  @Input() public category: string;
  @Input() public labelProp: string;
  @Input() public firstBarValueProp: string;
  @Input() public secondBarValueProp: string;
  @Input() public firstLineValueProp: string;
  @Input() public secondLineValueProp: string;
  @Input() public firstBarTitleProp: string;
  @Input() public secondBarTitleProp: string;
  @Input() public firstLineTitleProp: string;
  @Input() public secondLineTitleProp: string;
  @Input() public lineFilterProp: string;
  @Input() public chartTitle: string;
  @Input() public xAxisLabel: string;
  @Input() public yAxisLabel: string;
  @Input() public yAxisFormat: string;
  @Input()
  set isMobile(isMobile: boolean) {
    this.options = SharedConstants.chartOptions(this.yAxisFormat, isMobile);
    this.width = isMobile ? 340 : 500;
  }

  public chartData;
  public options;
  public width;

  public ngOnInit() {
    this.options.title.text = this.chartTitle;
    if (this.chartTitle) {
      this.options.title.display = true;
      this.options.title.text = this.chartTitle;
    }
    this.options.legend.display = true;
    this.options.scales.yAxes[0].ticks.beginAtZero = true;

    if (this.yAxisLabel) {
      this.options.scales.yAxes[0].scaleLabel.labelString = this.yAxisLabel;
      this.options.scales.yAxes[0].scaleLabel.display = true;
    }

    if (this.xAxisLabel) {
      this.options.scales.xAxes[0].scaleLabel.labelString = this.xAxisLabel;
      this.options.scales.xAxes[0].scaleLabel.display = true;
    }

    let labels = pluck(this.labelProp)(this.data);
    let firstBarValues = pluck(this.firstBarValueProp)(this.data);
    let secondBarValues = pluck(this.secondBarValueProp)(this.data);

    let firstLineValues = [];
    let secondLineValues = [];

    // If line chart shouldn't show a data point, insert null
    // so that chartJs can handle it correctly
    for (const monthData of this.data) {
      let shouldInclude = monthData[this.lineFilterProp];
      firstLineValues.push(shouldInclude ? monthData[this.firstLineValueProp] : null);
      secondLineValues.push(shouldInclude ? monthData[this.secondLineValueProp] : null);
    }

    this.chartData = {
      datasets: [{
        label: this.firstBarTitleProp,
        data: firstBarValues,
        borderColor: SharedConstants.categoryFadeColor(this.category),
        backgroundColor: SharedConstants.categoryFadeColor(this.category),
        hoverBackgroundColor: SharedConstants.categoryFadeColor(this.category),
        hoverBorderColor: SharedConstants.categoryFadeColor(this.category),
        borderWidth: 1,
        pointStyle: 'rect'
      }, {
        label: this.secondBarTitleProp,
        data: secondBarValues,
        borderColor: SharedConstants.categorySecondaryFadeColor(this.category),
        backgroundColor: SharedConstants.categorySecondaryFadeColor(this.category),
        hoverBackgroundColor: SharedConstants.categorySecondaryFadeColor(this.category),
        hoverBorderColor: SharedConstants.categorySecondaryFadeColor(this.category),
        borderWidth: 1,
        pointStyle: 'rect'
      }, {
        label: this.firstLineTitleProp,
        data: firstLineValues,
        type: 'lineOffsetLeft',
        fill: false,
        borderColor: SharedConstants.categoryColor(this.category),
        backgroundColor: SharedConstants.categoryColor(this.category),
        hoverBackgroundColor: SharedConstants.categoryColor(this.category),
        hoverBorderColor: SharedConstants.categoryColor(this.category),
        borderWidth: 1,
        pointStyle: 'line'
      }, {
        label: this.secondLineTitleProp,
        data: secondLineValues,
        type: 'lineOffsetRight',
        fill: false,
        borderColor: SharedConstants.categorySecondaryColor(this.category),
        backgroundColor: SharedConstants.categorySecondaryColor(this.category),
        hoverBackgroundColor: SharedConstants.categorySecondaryColor(this.category),
        hoverBorderColor: SharedConstants.categorySecondaryColor(this.category),
        borderWidth: 1,
        pointStyle: 'line'
      }],
      labels
    };
  }
}
